import { Component, OnInit } from "@angular/core";
import { environment } from "environments/environment";

@Component({
    selector: "dodo-id-verification",
    templateUrl: "./id-verification.component.html",
    styleUrls: ["./id-verification.component.scss"],
    standalone: false
})
export class IdVerificationComponent implements OnInit {

	constructor(){}

    ngOnInit(): void {
        this.redirectBackToMain();
      }
    
    public gotoMainSite(): void {
        window.location.href = environment[environment.envConfigName.env].durpalApiHost;
    }

    private redirectBackToMain(): void {
        history.pushState(null, '', window.location.href);
        window.addEventListener('popstate', (e) => {
            this.gotoMainSite();
        });

    }

    public mail(){
        let mailText = "mailto:idsupport@dodo.com.au?subject=ID Verification";
        window.location.href = mailText;
    }
}
